// Bundled into vite.config.ts (i18n preload links): type-only `@/` imports only, no value imports (the config loader cannot resolve them).
import { isOptOutFlagOn } from './feature-flag';

// Namespaces loaded before the first render (see main.tsx: loading them up
// front avoids remount flaps as locale files arrive). Page namespaces gated by
// a tenant flag load only when that page can exist.
export const preloadNamespaces = (env: { VITE_SHORT_MARKETS_API_PATH?: string; VITE_NOTIFICATIONS_ENABLED?: string }) => [
  'translation',
  'home',
  'market',
  'leaderboard',
  'user',
  'user-invite-earn',
  // The notification page exists unless VITE_NOTIFICATIONS_ENABLED is an off value (BON-249).
  ...(isOptOutFlagOn(env.VITE_NOTIFICATIONS_ENABLED) ? ['user-notification'] : []),
  'user-settings',
  'rewards',
  // The 5-minute page and the home card exist only with a short-market feed (pages/btc-5m).
  ...(env.VITE_SHORT_MARKETS_API_PATH ? ['btc5m'] : []),
];
